import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.seasonOverwrites.loading,
  writing: state.seasonOverwrites.writing,
  overwrites: state.seasonOverwrites.overwrites,
  writeError: state.seasonOverwrites.writeError,
  fetchOverwriteError: state.seasonOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
